import { Target } from "lucide-react";

import { WizardDefinition } from "../framework/types";
import { wizardMascots } from "../mascots/mascots";
import { CONVERSION_EVENTS_WIZARD_TYPE } from "./constants";
import { ConversionEventsContext, useConversionEventsContext } from "./context";
import { LowFunnelStep } from "./steps/LowFunnelStep";
import { MidFunnelStep } from "./steps/MidFunnelStep";
import { ReviewStep } from "./steps/ReviewStep";
import { ConversionEventsData } from "./types";

export const conversionEventsWizard: WizardDefinition<
  ConversionEventsData,
  ConversionEventsContext
> = {
  type: CONVERSION_EVENTS_WIZARD_TYPE,
  title: "Define conversion events",
  description:
    "Choose the events Attribution and Freshpaint AI measure across your project",
  Icon: Target,
  mascot: wizardMascots[CONVERSION_EVENTS_WIZARD_TYPE],
  searchKeys: ["conversion", "conversions", "funnel", "attribution", "goal"],
  createInitialData: () => ({
    bottomFunnelIds: null,
    midFunnelIds: null,
    seededBottomFunnelIds: null,
    seededMidFunnelIds: null,
    savedBottomFunnelNames: [],
    savedIncludesNewEvents: false,
  }),
  getCompletionSummary: (data, context) => ({
    title: "Conversions are set",
    description: [
      `Attribution now credits your campaigns for ${data.savedBottomFunnelNames.join(", ") || "your conversions"}.`,
      "Reports for past dates use the new conversions too, so historical numbers may change.",
      data.savedIncludesNewEvents &&
        "Newly defined events start counting after Freshpaint’s nightly update.",
      context.showRecommendationCards &&
        "Recommendation cards pick up the change on Monday morning.",
    ]
      .filter(Boolean)
      .join(" "),
  }),
  useStepContext: useConversionEventsContext,
  steps: [
    {
      id: "low-funnel",
      phase: "Choose",
      title: "Main conversion",
      Component: LowFunnelStep,
    },
    {
      id: "mid-funnel",
      phase: "Choose",
      title: "Steps along the way",
      Component: MidFunnelStep,
    },
    {
      id: "review",
      phase: "Save",
      title: "Review and save",
      Component: ReviewStep,
    },
  ],
};
